export const TranslationKeys = {
  Key: 'KEY',
  Salt: 'SALT',
  Hash: 'HASH',
  HashCode: 'HASH_CODE',
  NextHashCode: 'NEXT_HASH_CODE',
  Copied: 'COPIED',
  AboutHashCode: 'ABOUT_HASH_CODE',
  Calculate: 'CALCULATE',
  Check: 'CHECK',
  ProvablyFairness: 'PROVABLY_FAIRNESS',
  Calculator: 'CALCULATOR',
  GameRules: 'GAME_RULES',
  Reconnect: 'RECONNECT',
  ConnectionError: 'CONNECTION_ERROR',
  WinLose: 'WIN_LOSE',
  GameSettings: 'GAME_SETTINGS',
  Home: 'HOME',
  TotalWin: 'TOTAL_WIN',
  Ok: 'OK',
  ComboKeno_8: 'COMBO_KENO_8',
  ComboKeno_10: 'COMBO_KENO_10',
  TotalBet: 'TOTAL_BET',
  Min: 'MIN',
  Max: 'MAX',
  Tickets: 'TICKETS',
  ChooseNumbers: 'CHOOSE_NUMBERS',
  Last: 'LAST',
  Add: 'ADD',
  NextRound: 'NEXT_ROUND',
  LastTickets: 'LAST_TICKETS',
  ReBet: 'REBET',
  BetSlip: 'BET_SLIP',
  AllBets: 'ALL_BETS',
  Random: 'RANDOM',
  ClearTable: 'CLEAR_TABLE',
  Delete: 'DELETE',
  TicketId: 'TICKET_ID',
  Bet: 'BET',
  BetButton: 'BET_BUTTON',
  PossibleWin: 'POSSIBLE_WIN',
  Win: 'WIN',
  RoundId: 'ROUND_ID',
  Game: 'GAME',
  Result: 'RESULT',
  History: 'HISTORY',
  Fairness: 'FAIRNESS',
  PLayForReal: 'PLAY_FOR_REAL',
  Odd: 'ODD',
  Music: 'MUSIC',
  Sound: 'SOUND',
  TurboMode: 'TURBO_MODE',
  GameHistory: 'GAME_HISTORY',
  Date: 'DATE',
  NoTickets: 'NO_TICKETS',
  Rules: 'RULES',
  YouWin: 'YOU_WIN',
  BigWin: 'BIG_WIN',
  GameRules8P: 'GAME_RULES_KENO8_P',
  GameRules10P: 'GAME_RULES_KENO10_P',
  GameRules10P26: 'GAME_RULES_KENO10_P26',
  GameRules8P26: 'GAME_RULES_KENO8_P26',
  AboutHashCodeP: 'ABOUT_HASH_CODE_',
};
